import { render, staticRenderFns } from "./Ops.vue?vue&type=template&id=6fb96d36&scoped=true&"
import script from "./Ops.vue?vue&type=script&lang=js&"
export * from "./Ops.vue?vue&type=script&lang=js&"
import style0 from "./Ops.vue?vue&type=style&index=0&id=6fb96d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb96d36",
  null
  
)

export default component.exports